import { authApi, BASE_URL, formDataApi } from "./common";

export const getContractDetailsService = async (prospectId: string) => {
  const response = await authApi.get(
    `${BASE_URL}/get_digital_contract/${prospectId}`
  );
  return response;
};
export const createContractService = async ({
  prospectId,
  formData,
}: any) =>
  await formDataApi.post(
    `${BASE_URL}/submit_digital_contract/${prospectId}`,
    formData
  );
